import useSound from 'use-sound';
import sound from '../assets/sounds/ui-click.mp3';


export const useSoundClick = () => {
  const [play] = useSound(sound, {    volume: 0.2 });

  return play
}